import { getUserDisplayName } from "@src/utils";

import { useAuth } from "./use-auth";
import { useTeam } from "./use-team";

interface DisplayNameOptions {
  includeDisplayName?: boolean;
  youSuffix?: boolean;
}

interface User {
  uuid?: string;
  firstName?: string;
  lastName?: string;
}

/**
 * Returns the display name for the specified user.
 * If the user is a DVM in any known team, the Dr prefix will be added.
 */
export const useDisplayName = (
  user: User | null | undefined,
  options: DisplayNameOptions = {
    includeDisplayName: false,
    youSuffix: false,
  },
) => {
  const { userUuid } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { userTeams } = useTeam() as unknown as { userTeams: any[] };
  const displayName = getUserDisplayName(user, userTeams, options);

  if (options.youSuffix && user?.uuid === userUuid) {
    return displayName + " (You)";
  } else {
    return displayName;
  }
};
